<template>
  <v-card class="box-container ma-0 pa-0" style="max-height: 500px">
    <div class="row-header ma-0 pa-0 mb-2">
      <v-row class="ma-0 pa-0" justify="center" align="center">
        <v-btn color="none" text fab small class="no-background-hover" :ripple="false" style="cursor: default">
          <v-divider></v-divider>
        </v-btn>
        <v-divider></v-divider>
        <span class="ma-2 subtitle-1">{{ chooseColumns }}</span>
        <v-divider></v-divider>
        <v-btn color="error" text fab small @click="closeThis()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </div>
    <div class="row-header">
      <v-spacer></v-spacer>
    </div>
    <div class="ma-0 pa-0 row-content-limited customscroll">
      <v-switch class="ma-0 pa-0 ml-5 my-switch" style="height: 32px" hide-details v-for="(h, idx) in headers" :key="idx" v-model="selected" @change="setVisible(h)" :value="h.value" :label="h.text" :color="Colors.IconColor"></v-switch>
    </div>
  </v-card>
</template>

<script>
import DataManager from "../../js/DataManager";
import Translation from '../../js/Translation';
import { TR } from "../../main";
export default {
  props: {},
  data() {
    return {
      chooseColumns: TR.DGVColumnSelector_ChooseColumns,
      datatype: null,
      selected: [],
      headers: [],
      zzTheme: "light",
    };
  },
  methods: {
    closeThis() {
      //try {
      var user = DataManager.getData(DataManager.DataType.user, true);
      var cols = {};
      DataManager.headers.forEach((arr_vals, datatype_idx) => {
        var type = Object.keys(DataManager.DataType)[datatype_idx];
        cols[type] = {};
        arr_vals.forEach((v) => {
          if (v.hidden) {
            cols[type][v.value] = v.hidden;
          }
        });
      });
      if (JSON.stringify(user.settings1.columns) != JSON.stringify(cols) && TR.Locale == Translation.bg.Locale) {
        user.settings1.columns = cols;
        DataManager.updateUserSettings(user.settings1);
      }

      // } catch {
      //   //ignored
      // }

      this.dialog.close();
    },
    setVisible(h) {
      return (h.hidden = !h.hidden);
    },
    refreshTheme() {
      if (this.isInDarkMode) {
        if (this.zzTheme == "dark") return;
        this.zzTheme = "dark";
      } else {
        if (this.zzTheme == "light") return;
        this.zzTheme = "light";
      }
    },
  },
  computed: {
    getTheme() {
      return this.refreshTheme();
    },
  },
  created() {
    this.datatype = this.dialog.data;
    this.headers = DataManager.getHeaders(this.datatype).filter((h) => h.isInSelector);
    this.selected = this.headers.filter((f) => !f.hidden).map((h) => h.value);
  },
  beforeDestroy() {},
  watch: {
    selected: function (newVal, oldVal) {
      this.headers.forEach((f) => {
        if (oldVal.indexOf(f) !== -1) {
          f.hidden = false;
        }
      });
    },
  },
};
</script>

<style>
.v--modal-background-click {
  backdrop-filter: blur(3px);
}
.size-modal-content {
  padding: 10px;
  font-style: 12px;
}
.v--modal-overlay[data-modal="size-modal"] {
  background: rgba(0, 0, 0, 0.5);
}
.demo-modal-class {
  border: 1px solid #d84315;
  border-radius: 5px;
  /* background: #F7F7F7; */
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
</style>
<style scoped>
h3 {
  background: gray;
  cursor: move;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}

.my-switch >>> label {
  font-size: 14px;
}

.light {
  background: #f7f7f7;
  color: black;
}
.dark {
  background: black;
  color: #f7f7f7;
}
</style>
